import React from "react";

const Separator = ({
    size = 16,
    variant = "horizontal",
    inline = true
}) => {
    // const size = props.size || 16;
    // const variant = props.variant || "horizontal"

    const style = {
        [variant === "vertical" ? "height" : "width"] : `${size}px`,
        display: `${inline ? "inline-" : ""}block`
    };

    return <div style={style}></div>;
};

export default Separator;